var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view publish-offer"},[(_vm.showModal)?_c('CancelModal',{on:{"closeModal":_vm.hideModal}}):_vm._e(),_c('h3',{staticClass:"section-title"},[_vm._v("Publicación de oferta")]),_c('PreOfferCard'),_c('PublishCard',{on:{"showModal":function($event){_vm.showModal=true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }